export default "__VITE_ASSET__6867e371__"